import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "magento-recaptcha"
    }}>{`Magento reCAPTCHA`}</h1>
    <p>{`Google reCAPTCHA ensures that a human being, rather than a computer (or “bot”), is interacting with your website. Unlike the standard Magento CAPTCHA, Google reCAPTCHA provides enhanced security with a selection of different display options and methods. Additional website traffic information is available in the dashboard of your Google reCAPTCHA account.`}</p>
    <p>{`This module provides the reCAPTCHA implementations related to the contact page.`}</p>
    <p>{`For more information please visit the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/commerce-admin/systems/security/captcha/security-google-recaptcha"
      }}>{`reCAPTCHA documentation`}</a>{`.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 1.1.4.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      